import Cookies from 'universal-cookie';
const cookies = new Cookies()

export const setCookie = (name: string = '', value: string, options = {}) => {
    cookies.set(name, value, { path: '/', ...options })
}

export const getCookie = (name = '', options = {}) => {
    return cookies.get(name, options)
}

export const cookieListener = (callback = () => null) => {
    cookies.addChangeListener(callback)
}

// Cookie read must never block registration - any failure yields ''
const safeGetCookie = (name: string): string => {
    try {
        const value = cookies.get(name, { doNotParse: true });
        return typeof value === 'string' ? value : '';
    } catch (e) {
        return '';
    }
}

// Repeated params (?oppref=&oppref=b) - take the first non-empty value
const safeGetQueryParam = (name: string): string => {
    try {
        if (typeof window === 'undefined') return '';
        return new URLSearchParams(window.location.search).getAll(name).find(value => value !== '') ?? '';
    } catch (e) {
        return '';
    }
}

// OpenAI Ads referrers for User/SetupNewEmail: query param first, then the OpenAI Pixel cookie, then ''.
// _oppref is a legacy fallback for the single-underscore spelling. Read-only, raw value, never throws.
export const getOpenAIAdsRefs = (): { oppref: string; obref: string } => ({
    oppref: safeGetQueryParam('oppref') || safeGetCookie('__oppref') || safeGetCookie('_oppref') || '',
    obref: safeGetQueryParam('obref') || safeGetCookie('__obref') || '',
})